import React from "react";

const Storybook = ({
  style = {},
  className = "",
  viewBox = "0 0 83 102.3",
  color = "#fff",
  background = "#FF4785",
  ...rest
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox={viewBox}
      style={style}
      {...rest}
    >
      <rect width="100%" height="100%" fill="none"></rect>
      <defs>
        <path
          id="a"
          d="M3 94L0 10a5 5 0 015-5l72-5a5 5 0 015 5v92a5 5 0 01-5 5L8 99a5 5 0 01-5-5z"
        ></path>
      </defs>
      <mask id="b" fill={color}>
        <use xlinkHref="#a"></use>
      </mask>
      <g className="currentLayer">
        <use fill={background} xlinkHref="#a"></use>
        <path
          fill={color}
          d="M61 13V1l10-1v12a1 1 0 01-1 1l-4-3-4 3a1 1 0 01-1 0zM48 39c0 2 14 1 15-1 0-13-7-21-20-21-14 0-21 8-21 19 0 19 25 19 25 29 0 3-1 5-4 5-4 0-6-2-6-9 0-2-15-2-16 0-1 17 10 22 22 22s21-6 21-18c0-20-26-20-26-30 0-4 3-4 5-4s5 0 5 8z"
          mask="url(#b)"
        ></path>
      </g>
    </svg>
  );
};

export default Storybook;
